import React from 'react';
import ErrorsWrapper from '../../../uibuilder/form/input/layout/ErrorsWrapper';
import { CheckboxLayoutProps } from '../../../uibuilder/form/input/Checkbox';
import { Checkbox, cn } from 'shadcn-ui';

function ShadcnCheckboxLayout(props: CheckboxLayoutProps) {
  return (
    <ErrorsWrapper name={props.name} errors={props.errors}>
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label
        className={cn(
          'inline-flex items-center gap-2 cursor-pointer select-none text-sm text-foreground',
          props.matchTextInputHeight && 'min-h-[44px]',
          props.isDisabled && 'cursor-default opacity-50',
          props.className,
        )}
        title={props.title}
        data-testid={props.testId}
      >
        <Checkbox
          className="mr-1"
          checked={props.value || false}
          onCheckedChange={(checked) => {
            if (props.onChangeCallback) {
              props.onChangeCallback({
                target: {
                  value: !!checked,
                },
              });
            }
          }}
          disabled={props.isDisabled}
          name={props.name}
        />
        {!props.hideLabel && (
          props.labelComponent
            ? props.labelComponent
            : props.label && (
              props.isHighlighted
                ? <b>{props.label}</b>
                : <span>{props.label}</span>
            )
        )}
        {props.hint && (
          <span className="text-xs text-muted-foreground">{props.hint}</span>
        )}
      </label>
    </ErrorsWrapper>
  );
}

export default ShadcnCheckboxLayout;
